import { createApp } from '@wu/widget-core';
import { Button } from './button';
import { meta } from './meta';

export default createApp(meta, Button);
